import { makeStyles } from '@fluentui/react';

export const useStyles = makeStyles((theme) => ({
  iconStyle: {
    paddingTop: 8,
  },
}));
